import { render, staticRenderFns } from "./DatasetLogDetail.vue?vue&type=template&id=b80128fe&lang=pug"
import script from "./DatasetLogDetail.vue?vue&type=script&lang=js"
export * from "./DatasetLogDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b80128fe')) {
      api.createRecord('b80128fe', component.options)
    } else {
      api.reload('b80128fe', component.options)
    }
    module.hot.accept("./DatasetLogDetail.vue?vue&type=template&id=b80128fe&lang=pug", function () {
      api.rerender('b80128fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/powerbi/components/DatasetLogDetail.vue"
export default component.exports